import { useCallback, useEffect, useState } from 'react'
import axios from 'axios'
import { Customer } from '@medusajs/medusa'
import { bhStoreApiRequest } from '@lib/request'

/** Return a boolean for whether or not the provided customer's account has
 * been admin by Barnhill or not. */
function useCustomerIsAdmin(
  customer?: Omit<Customer, 'password_hash'>
): boolean {
  const [isAdmin, setIsAdmin] = useState(false)
  const checkIsAdmin = useCallback(async () => {
    if (customer) {
      // check if the customer is a b2b customer
      const { data } = await bhStoreApiRequest<{
        isAdmin: boolean
      }>(`/customers/is-admin`)
      setIsAdmin(data.isAdmin)
    } else {
      setIsAdmin(false)
    }
  }, [customer])

  useEffect(() => {
    checkIsAdmin()
  }, [checkIsAdmin])

  return isAdmin
}

export default useCustomerIsAdmin
